import typeChecker from '../typeChecker'

export enum AnswerStatus {
  ALL = 'ALL',
  NOT_YET = 'NOT_YET',
  COMPLETED = 'COMPLETED',
}

export namespace AnswerStatus {
  const value = {
    ALL: { text: '답변상태', nclick: 'sall' },
    NOT_YET: { text: '미답변', nclick: 'snot' },
    COMPLETED: { text: '답변완료', nclick: 'sfin' },
  }

  export const getText = (status: AnswerStatus) => value[status].text
  export const getNClick = (status: AnswerStatus) => value[status].nclick
  export const getValues = (): AnswerStatus[] =>
    Object.keys(AnswerStatus)
      .filter(e => value[e] && typeChecker.isString(value[e].text))
      .map(e => AnswerStatus[e])
}
